import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	Input,
	OnDestroy,
	OnInit,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import {
	IAssigneeTeam,
	IAssigneeUser,
} from '@shared/interfaces/selectable-options.interfaces';

import { AuLogoPlaceholderModule, AuRoundAvatarModule } from '@shared/ui-components';

@Component({
	selector: 'input-type-block',
	templateUrl: './input-type-block.component.html',
	styleUrls: ['./input-type-block.component.scss'],
	imports: [AuLogoPlaceholderModule, AuRoundAvatarModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputTypeBlockComponent implements OnInit, OnDestroy {
	@Input() placeholder = 'Choose an option';
	@Input() value: IAssigneeTeam | IAssigneeUser;
	@Input() blurEvent: Subject<void>;

	focused = false;

	private subscription = new Subscription();

	constructor(private cd: ChangeDetectorRef) {}

	ngOnInit() {
		this.subscription = this.blurEvent.subscribe(() => {
			this.focused = false;
			this.cd.detectChanges();
		});
	}

	getLogoSrc(): string {
		if (this.value && 'smallAvatarUrl' in this.value) {
			return this.value.smallAvatarUrl;
		}
	}

	getFallbackSrc(): string {
		if (!this.value) {
			return './assets/icons/user.svg';
		} else if (this.value.contentType === 'team') {
			return './assets/icons/users_group.svg';
		} else if (this.value.contentType === 'organization') {
			return './assets/icons/organization.svg';
		} else {
			return './assets/icons/user.svg';
		}
	}

	get blockTypePlaceholderText(): string {
		if (this.value && 'name' in this.value && this.value.name) {
			return this.value.name;
		}
		if (this.value && 'firstName' in this.value && this.value.firstName) {
			return `${this.value.firstName} ${this.value.lastName}`;
		}
		return this.placeholder;
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
}
